import React, { ReactNode } from "react";
import layoutPublicRoutesStyle from "@/src/containers/Layouts/layoutPublicRoutesStyle";
import Footer from "@/src/components/Footer/Footer";
import ReleaseInfo from "@/src/components/ReleaseInfo/ReleaseInfo";
import ScrollTopButton from "@/src/components/Button/ScrollTopButton";
import { AppBar, Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import Toolbar from "@mui/material/Toolbar";
import advocardLegalbirdCooperationLogo from "@/src/assets/img/logo/advocard_legalbird_cooperation_logo.png";
import { withScroll } from "@/src/services/withScroll";

type LayoutAdvocardFlexProps = {
  children: ReactNode;
  scrollPosition: number;
  withScrollToTopButton?: boolean;
};

function LayoutAdvocardFlex({ children, scrollPosition, withScrollToTopButton = true }: LayoutAdvocardFlexProps) {
  const scrolledStyle = scrollPosition > 1;

  return (
    <>
      <ReleaseInfo />
      <AppBar position={"fixed"} color={scrolledStyle ? "inherit" : "transparent"} elevation={scrolledStyle ? 4 : 0}>
        <Toolbar>
          <Grid
            container
            columnSpacing={5}
            sx={[{
              alignItems: "center",
              width: "100%",
            }, layoutPublicRoutesStyle.navigationContainer]}>
            <Grid sx={{
              margin: 2
            }}>
              <Box
                component={"img"}
                src={advocardLegalbirdCooperationLogo}
                alt={"Advocard Legalbird Kooperation"}
                sx={{ width: "200px" }}
              />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Box sx={layoutPublicRoutesStyle.pageContainer}>
        <Box sx={layoutPublicRoutesStyle.content}>
          <Box sx={layoutPublicRoutesStyle.childrenContainer}>{children}</Box>
          <Footer hideProductLinks={true} />
        </Box>
      </Box>
      {withScrollToTopButton && <ScrollTopButton />}
    </>
  );
}

export default withScroll(LayoutAdvocardFlex);
